import { linkButtonClasses } from "./buttonStyles";

export type LinkButtonProps = {
  label: string;
  onClick: () => void;
};

export const LinkButton = (props: LinkButtonProps) => {
  const { label, onClick } = props;
  const classes = linkButtonClasses();
  return (
    <button onClick={onClick} className={classes}>
      {label}
    </button>
  );
};
